import { render, staticRenderFns } from "./CheckoutGiftPackaging.vue?vue&type=template&id=21258a4e&scoped=true"
import script from "./CheckoutGiftPackaging.vue?vue&type=script&lang=js"
export * from "./CheckoutGiftPackaging.vue?vue&type=script&lang=js"
import style0 from "./CheckoutGiftPackaging.vue?vue&type=style&index=0&id=21258a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21258a4e",
  null
  
)

export default component.exports